<template>
  <ul id="list-tasks">
    <li>
      <!--pc view-->

      <div id='oblea'  style="height: 90px" v-show="it.tipoOblea == 1 && !mobileView">
        <div id='s1'>
          <img :src="imagenProducto" style="height: 52px" /> 
        </div> 
        <div style="width: 25%; height: 100%; display: flex; flex-direction: column;  justify-content: center; align-items: flex-start; padding-left: 10px" :title="item.producto">
          <div v-show="item.esPromo" class="fh lc">
            <img  style="width: 27px;" src="/dist/icon_promo.png"   />
          </div>
          <span style="text-align: center;" id='titulo'>{{item.producto}}</span>
          <div>
            <span class='label'>Precio:</span> 
            <span class='value'>${{precio | formatMoney}}</span>
          </div>
        </div> 
        <div id='s3'>
          <div id='cc'>
            <span id='label-cantidad'>Cantidad</span> 
            <input class='cantidad' :class="{cantidadInv: cantInvalida}" type="text" v-model="it.cantidad" v-on:keyup="updateCantidad">
            <span style="margin-top: 5px; font-size: 8px; color: #5C666F; margin-right: 5px">{{labelUnidades}}</span> 
          </div> 
          <span :class='{itemMaximoPorcentaje:!cantInvalida,itemMaximoPorcentajeInv:cantInvalida}' style="margin-top: 4px" v-show='showLimiteMaximo'>{{maxUnidades}}</span>
          <span :class='{itemMaximoPorcentaje:!cantInvalida,itemMaximoPorcentajeInv:cantInvalida}' style="margin-top: 4px" v-show='showMinUnidades'>{{minUnidades}}</span>
          <span :class='{itemMaximoPorcentaje:esMultiploValido,itemMaximoPorcentajeInv:!esMultiploValido}' style="margin-top: 4px" v-show='showUnidadesDeVenta'>(Packs de {{it.unidadesPorPedido}} unidades)</span>
          <span class='itemMaximoPorcentajeInv' style="margin-top: 4px" v-show='!esMultiploValido'>{{valorCercano}}</span>
          <div id='cc' v-show='showDescuentos' style="margin-top: 10px;">
            <span id='label-cantidad' style="margin-top: 5px">Descuento</span> 
            <input class='cantidad' :class="{cantidadInv: porcentInvalido}"  type="text" v-model="it.porcentajeDescuento" v-on:keyup="updatePorcentaje">
            <span style="font-size: 8px; color: #5C666F; margin-right: 16px">%</span> 
          </div> 
          <span :class='{itemMaximoPorcentaje:!porcentInvalido,itemMaximoPorcentajeInv:porcentInvalido}' style="margin-top: 4px" v-show='showDescuentos'>{{maximoDescuento}}</span>
        </div> 
        <div id='s4'>
          <img id='btnEliminarItem'  @click="btnEliminarItem"  src="/dist/icon-delete.png"  style= "width:20px;height:20px">   
        </div> 
        <div id='s3'>
          <div style="margin-top: 5px">
            <span class='label'>Subtotal:</span>
            <span class='value'  style="width: 90px; text-align: right; padding-right: 5px">${{subtotal | formatMoney}}</span>
          </div> 
        </div> 
      </div>

      <div id='oblea-desc' v-show="it.tipoOblea == 2 && !mobileView" >
          <div id='s1'>
          </div> 
          <div id='s2' style="width: 73%">
            <span id='titulo'>{{item.producto}}</span>
          </div> 
          <div id='s3' style="width: 15%">
             <div class="fh lc" style="font-size: 12px; color: #656E76; margin-right: 5px">
                   ${{item.precio | formatMoney}}
              </div>
          </div> 
      </div>


      <!--mobile view-->
      <div class="fv ct" style="margin-bottom: 20px; width:90vw; border-style: solid;border-width: 1px; border-color: #dddddd; border-radius: 10px;  box-shadow: 2px 2px 4px #dddddd; -webkit-box-shadow: 2px 2px 4px #dddddd; -moz-box-shadow:2px 2px 4px #dddddd;" v-show="it.tipoOblea == 1  && mobileView">
        <div class="fh cc" style="width:100%; height:114px">
          <div class="fv cc" style="width:40%; height:100%;" >
            <img style="width: 80%" :src="imagenProducto"/>
          </div>
          <div class="fv cc" style="width:60%; height:100%;" >
            <div class="fh lc" style="font-size: 20px; font-weight: 800; color: #5C666F"> {{item.producto}} </div>
            <div class="fh lc" style="font-size: 15px; font-weight: 500; margin-top: 15px; color: #5C666F"> Precio: ${{precio | formatMoney}}</div>
            <div class="fh lc" style="font-size: 12px; font-weight: 500; margin-top: 10px; color: #5C666F"> Subtotal: ${{subtotal | formatMoney}}</div>
          </div>
        </div>
        <div class="fh lc" style="width:100%; height:57px;">
          <div class="fh rc" style="width:50%; height:100%;">
            <div class="fh lc" style="font-size: 12px; font-weight: 500; color: #5C666F">Cantidad</div>
            <input class='cantidad' :class="{cantidadInv: cantInvalida}" type="text" v-model="it.cantidad" v-on:keyup="updateCantidad">
            <div class="fh cc" style="font-size: 10px; color: #5C666F; width: 30px">{{labelUnidades}}</div> 
          </div>
        </div>
      </div>
      <div class="fh lc" v-show="it.tipoOblea == 2 && mobileView" style="width: 90vw; height:30px; margin-top: 10px; margin-bottom: 5px; background-color: #ffffaa; border-style: solid; border-width: 1px; border-color:#dddddd; border-radius: 10px; box-shadow: 1px 1px 3px #dddddd;">
          <div class="fh cc" style="width: 50%;">
            <span id='titulo'>{{item.producto}}</span>
          </div> 
          <div class="fh cc" style="width: 50%;">
            <span class='label-desc'>Descuento:</span> 
            <span class='value'> ${{item.precio | formatMoney}}</span>
          </div> 
      </div>
    </li>
  </ul>
</template>


<script>
  import axios from 'axios'

  export default {
    name: 'item-pedido',
    props: ['item'],
    data()  {
       return {
        cantInvalida: false,
        porcentInvalido: false,
         it: this.item ,
         valor:'',
       //  imagenProducto: '',
         unidadesPedido:0,
         multiplo:0,
         multiploValido:true,
         mobileView:false
       }
    },

    watch: {
      item: {
        immediate: true,
        handler  () {
          //this.getImage()
        }
      }
    },


    computed: {

     precio() {
        var precio = 0
        if (this.it.porcentajeDescuento) {
           precio = this.it.precio-(this.it.precio*(this.it.porcentajeDescuento/100))
        } 
        else {
           precio = this.it.precio
        }
        return precio
      },

      subtotal() {
        var sub = 0
        if (this.it.porcentajeDescuento) {
           sub = this.it.precio-(this.it.precio*(this.it.porcentajeDescuento/100))
        } 
        else {
           sub = this.it.precio
        }
        return this.it.cantidad*sub
      },

      labelUnidades() {
        if (this.it.cantidad > 1)
        {
          return 'uds.';
        }
        else
        {
          return 'unid';
        }
      },

      imagenProducto() {
        if ((this.item.ImagenUrl != null)&&(this.item.ImagenUrl != '')) {
          return this.item.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        }
      } 
    },


    methods: {

      onResize() {
        if (window.innerWidth > 600) 
        {
          this.mobileView=false;
        }
        else 
        {
          this.mobileView=true;
        }
      },

      btnEliminarItem() {
        this.$emit('eliminarItem', this.item.id);
       },

      updateCantidad() {
        var rex  = new RegExp(/^\d+$/);
        var rex2 = new RegExp(/^[0-9]+([.,][0-9]+)?$/);;

        if (this.item.permiteDecimales) {
            if (rex2.test(this.it.cantidad))  
            {
                this.cantInvalida = false
            }
            else {
                this.cantInvalida = true
            }
            if (this.it.cantidad.includes(',')){
                this.it.cantidad = this.it.cantidad.replace(',','.')
            } 
        }
        else {
            if (rex.test(this.it.cantidad))  
            {
                console.log(this.item)
                var minVenta = 1
                if (this.item.unidadesMinimaVenta > 1)
                {
                    minVenta = this.item.unidadesMinimaVenta
                }

                if (this.it.cantidad >= minVenta)
                {
                    this.cantInvalida = false
                }
                else
                {
                    this.cantInvalida = true
                }
            }
            else
            {
                this.cantInvalida = true
            }
        }
        this.updateItem()
      },


      updateItem(){

        var itemUpdate = {
                          'ImagenUrl': this.item.ImagenUrl,
                          'cantidad': parseFloat(this.it.cantidad),
                          'descripcion': this.item.descripcion,
                          'id': this.item.id,
                          'idCategoria': this.item.idCategoria,
                          'idSubcategoria': this.item.idSubcategoria,
                          'peso': this.item.peso,
                          'precio': this.item.precio,
                          'producto': this.item.producto,
                          'promocionId': this.item.promocionId, 
                          'tipoOblea': this.item.tipoOblea,
                          'unidadesPorPedido': this.item.unidadesPorPedido,
                          'unidadesMinimaVenta': this.item.unidadesMinimaVenta,
                          'porcentajeDescuento': parseInt(this.it.porcentajeDescuento),
                          'permiteDecimales': this.item.permiteDecimales,
                          'porcentajeImpuesto': this.item.porcentajeImpuesto,
                         }

        this.$store.commit('pedido/updateItemCarrito',itemUpdate)
      }

  },

   mounted () {
    this.onResize()
   },

   created() {
     window.addEventListener('resize', this.onResize)
   },

   beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
   }

  }
</script>


<style scoped>

* {
  margin:  0;
  padding: 0;
}



#oblea {
  width: 630px;
  height:120px;  
  margin-bottom: 5px;
  background-color: #ffffff;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
  justify-content: center;
}

#oblea-desc {
  width: 630px;
  height:30px;
  margin-bottom: 5px;
  background-color: #ffffaa;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}



#s1{
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 27%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}

#s222{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center; 
}

#s3{
  width: 30%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-end;  
}

#s4{
  width: 8%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}


.itemMaximoPorcentaje{
  font-size: 8px; 
  color: #5C666F;
  display: flex;
  align-items: flex-end
}

.itemMaximoPorcentajeInv{
  font-size: 8px; 
  color: #FF0000;
  display: flex;
  align-items: flex-end
}




#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}


.label-desc{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 70px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#label-subtotal{
  font-size: 12px;
  color: #656E76;
  margin-left: 10%;
}


#label-cantidad {
 font-size: 12px;
 color: #656E76;
 font-weight: 500;
 }


.cantidad {
  width: 40px;
  height: 18px;
  margin-left: 5px;
  border-radius: 4px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  text-align: center;
  color: #656E76;
  outline: none;
  }


.cantidadInv {
  width: 40px;
  height: 18px;
  margin-left: 5px;
  border-radius: 4px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #ff0000;
  text-align: center;
  color: #656E76;
  outline: none;
  }


#btnEliminarItem:hover{
  cursor: pointer;  
}


 </style>


// WEBPACK FOOTER //
// src/components/views/devoluciones/ItemDevolucion.vue